<template>
  <div style="padding: 10px; background-color: red; color: white" class="d-none">
    DEBUG: LiteVersion: {{ isLite }}
  </div>
  <router-view />
  <MDBModal side direction="right" tabindex="-1" labelledby="exampleModalLabel" v-model="showHint" class="intro__modal"
    style="background: transparent" :class="[`${user?.intro == 3 ? 'intro__bottom' : ''}`]">
    <Content />
  </MDBModal>
  <div class="intro__bg" v-if="showHint"></div>
  <RequiredConsentModal v-if="!isNlTemporaryConsentBypass" v-model="showRequiredConsentModal" :consents="consents"
    :loading="consentsLoading" @accepted="handleRequiredConsentAccepted" />
</template>

<script setup>
import Content from "@/components/Intro/Content.vue";
import RequiredConsentModal from "@/components/Consents/RequiredConsentModal.vue";
import { MDBModal } from "mdb-vue-ui-kit";

import { computed, watch, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import TokenService from "@/services/storage.service";
import { useRequiredConsents } from "@/composables/useRequiredConsents";
import { CONSENT_TYPE } from "@/configs/constants";

const store = useStore();
const route = useRoute();
const router = useRouter();
const user = computed(() => store.getters.getMe);
const isUnknown = computed(() => store.getters.getIsUnknown);

const urlTenantId = computed(
  () =>
    window.location.href.match(/plus-([a-z]{2})\.bsplus\.bridgestone\.eu/i)?.[1]?.toUpperCase() || ""
);
const tenantId = computed(() =>
  String(store.getters.tenantId || urlTenantId.value || "").trim().toUpperCase()
);
const currentLocale = computed(() =>
  String(store.getters.getCurrentLocale || localStorage.getItem("currentLocale") || "").trim()
);
const isNlTemporaryConsentBypass = computed(
  () => tenantId.value === "NL" || currentLocale.value === "nl-NL"
);

const {
  consents,
  userHasRequiredConsents,
  loading: consentsLoading,
} = useRequiredConsents(CONSENT_TYPE.ONBOARDING, {
  enabled: computed(() => !isNlTemporaryConsentBypass.value),
});

const showRequiredConsentModal = ref(false);
const appMounted = ref(false);

watch(
  [appMounted, userHasRequiredConsents, () => route.name, isNlTemporaryConsentBypass],
  ([mounted, hasConsents, , disableNlConsents]) => {
    if (disableNlConsents) {
      showRequiredConsentModal.value = false;
      return;
    }
    if (mounted && !["login", "maintenance"].includes(route.name)) {
      showRequiredConsentModal.value = hasConsents;
    }
  }
);

const handleRequiredConsentAccepted = async () => {
  try {
    await store.dispatch("me");
    await store.dispatch('fetchTenantPermissions', true)
    await router.push({ name: "dashboard" });
  } catch (err) {
    console.error("Error after accepting consents:", err);
  }
};
const LANG = localStorage.getItem("lang");
const isLite = computed(() => store.getters.isLiteVersion).value;
import { useTenantConfig } from "@/composables/useTenantConfig";

const { tenantConfig } = useTenantConfig();

const showHint = computed(() => {
  if (isUnknown.value || isLite) {
    return false;
  }
  return user.value?.intro < tenantConfig.value.hintMaxStep;

});
const firstLoad = ref(true);

watch(
  () => route.query,
  (newVal) => {
    if (newVal.token && newVal.userId) {
      store.dispatch("userB2CLogin", {
        token: newVal.token,
        userId: newVal.userId,
      });
    }
    if (newVal.adminHashId) {
      TokenService.saveAdminHashId(newVal.adminHashId);
    }
  }
);

watch(
  () => route.meta,
  (newVal) => {
    if (!isLite) {
      if (newVal.requiredLang && !newVal.requiredLang.includes(LANG)) {
        router.push({
          name: "accessDenied",
        });
      }
    }
  }
);

watch(() => route.name, (newVal) => {
  const routes = ["shopCategory", "productDetails"]
  if (!routes.includes(newVal)) {
    TokenService.removeProductPage()
    TokenService.removeProductName()
    TokenService.removeProductPointsFrom()
    TokenService.removeProductPointsTo()
  }
})

onMounted(async () => {
  if (route.query.token && route.query.userId) {
    await store.dispatch("userB2CLogin", {
      token: route.query.token,
      userId: route.query.userId,
    });
    appMounted.value = true;
    return;
  }
  if (TokenService.getToken()) {
    await store.dispatch("me").catch(() => null);
  }
  appMounted.value = true;
});

setInterval(() => {
  if (firstLoad.value) {
    firstLoad.value = false;
  } else {
    window.location.reload(true);
  }
}, 360000);

</script>

<style lang="scss">
@import "./styles/fonts";
@import "./styles/global";

body>#app>.intro__bg {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  z-index: 1050;
}
</style>
